<app-table
  [service]="logService"
  [cols]="cols"
  modelName="logs"
  [addButton]="false"
  pageFunctionName="getLogs"
  sortField="logDate"
  [sortOrder]="1"
/>
